// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-chat-conversation {
  display: block;
  max-height: 100%;
  overflow: visible;
  min-height: 200px;
  height: 100%;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-chat/fi-chat-conversation/fi-chat-conversation/fi-chat-conversation.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AACJ","sourcesContent":[".fi-chat-conversation {\r\n    display: block;\r\n    max-height: 100%;\r\n    overflow: visible;\r\n    min-height: 200px;\r\n    height: 100%;\r\n    position: relative;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
